import PROFILE_FIELD from "Constants/profileFields";
import SIGNUP_FIELDS from "Constants/signupFields";

import { ACCOUNT_TYPE } from "Services/user";

import {
  SET_ACCOUNT_TYPE,
  SET_COUNTRY,
  SET_PROFILE,
  CREATE_PROFILE_REQUESTED,
  CREATE_PROFILE_OK,
  CREATE_PROFILE_FAIL,
  TOGGLE_TERMS_MODAL,
  SET_REF_ID,
} from "actions/signup";

const INITIAL_STATE = {
  data: {
    [PROFILE_FIELD.ACCOUNT_TYPE]: ACCOUNT_TYPE.INDIVIDUAL,
    [PROFILE_FIELD.IS_AGREE_NEWS_LETTER]: true,
  },
  errors: {
    [PROFILE_FIELD.EMAIL]: undefined,
    [PROFILE_FIELD.CITY]: undefined,
    [PROFILE_FIELD.ADDRESS]: undefined,
    [PROFILE_FIELD.MESSENGER]: undefined,
    [PROFILE_FIELD.PHONE_NUMBER]: undefined,
    [PROFILE_FIELD.LANGUAGE]: undefined,
    [PROFILE_FIELD.IS_AGREE_NEWS_LETTER]: undefined,
    [PROFILE_FIELD.VAT]: undefined,
    [PROFILE_FIELD.LAST_NAME]: undefined,
    [PROFILE_FIELD.FIRST_NAME]: undefined,
    [PROFILE_FIELD.ACCOUNT_TYPE]: undefined,
    [PROFILE_FIELD.COMPANY_NAME]: undefined,
    [PROFILE_FIELD.BENEFICIARY_ID]: undefined,
    [PROFILE_FIELD.RESIDENCE_COUNTRY]: undefined,
    [SIGNUP_FIELDS.AGREEMENT]: false,
  },
  isCompany: false,
  isVatCountry: false,
  isRedirectToVerificationEmail: false,
  isTermsShow: false,
  loading: false,
};

export function signupReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case CREATE_PROFILE_REQUESTED:
      return {
        ...state,
        errors: {
          ...INITIAL_STATE.errors,
        },
        loading: true,
      };

    case CREATE_PROFILE_OK:
      return {
        ...state,
        isRedirectToVerificationEmail: true,
        loading: false,
      };
    case CREATE_PROFILE_FAIL:
      return {
        ...state,
        loading: false,
        errors: {
          [PROFILE_FIELD.EMAIL]: action.errors[PROFILE_FIELD.EMAIL]
            ? action.errors[PROFILE_FIELD.EMAIL]
            : INITIAL_STATE.errors[PROFILE_FIELD.EMAIL],

          [PROFILE_FIELD.CITY]:
            action.errors.contact_info &&
            action.errors.contact_info[PROFILE_FIELD.CITY]
              ? action.errors.contact_info[PROFILE_FIELD.CITY]
              : INITIAL_STATE.errors[PROFILE_FIELD.CITY],

          [PROFILE_FIELD.ADDRESS]:
            action.errors.legal_info &&
            action.errors.legal_info[PROFILE_FIELD.ADDRESS]
              ? action.errors.legal_info[PROFILE_FIELD.ADDRESS]
              : INITIAL_STATE.errors[PROFILE_FIELD.ADDRESS],

          [PROFILE_FIELD.MESSENGER]:
            action.errors.contact_info &&
            action.errors.contact_info[PROFILE_FIELD.MESSENGER]
              ? action.errors[PROFILE_FIELD.MESSENGER]
              : INITIAL_STATE.errors[PROFILE_FIELD.MESSENGER],

          [PROFILE_FIELD.MESSENGER_TYPE]:
            action.errors.contact_info &&
            action.errors.contact_info[PROFILE_FIELD.MESSENGER_TYPE]
              ? action.errors[PROFILE_FIELD.MESSENGER_TYPE]
              : INITIAL_STATE.errors[PROFILE_FIELD.MESSENGER_TYPE],

          [PROFILE_FIELD.PHONE_NUMBER]:
            action.errors.contact_info &&
            action.errors.contact_info[PROFILE_FIELD.PHONE_NUMBER]
              ? action.errors.contact_info[PROFILE_FIELD.PHONE_NUMBER]
              : INITIAL_STATE.errors[PROFILE_FIELD.PHONE_NUMBER],

          [PROFILE_FIELD.VAT]:
            action.errors.legal_info &&
            action.errors.legal_info[PROFILE_FIELD.VAT]
              ? action.errors.legal_info[PROFILE_FIELD.VAT]
              : INITIAL_STATE.errors[PROFILE_FIELD.VAT],

          [PROFILE_FIELD.LAST_NAME]:
            action.errors.legal_info &&
            action.errors.legal_info[PROFILE_FIELD.LAST_NAME]
              ? action.errors.legal_info[PROFILE_FIELD.LAST_NAME]
              : INITIAL_STATE.errors[PROFILE_FIELD.LAST_NAME],

          [PROFILE_FIELD.FIRST_NAME]:
            action.errors.legal_info &&
            action.errors.legal_info[PROFILE_FIELD.FIRST_NAME]
              ? action.errors.legal_info[PROFILE_FIELD.FIRST_NAME]
              : INITIAL_STATE.errors[PROFILE_FIELD.FIRST_NAME],

          [PROFILE_FIELD.COMPANY_NAME]:
            action.errors.legal_info &&
            action.errors.legal_info[PROFILE_FIELD.COMPANY_NAME]
              ? action.errors.legal_info[PROFILE_FIELD.COMPANY_NAME]
              : INITIAL_STATE.errors[PROFILE_FIELD.COMPANY_NAME],

          [PROFILE_FIELD.RESIDENCE_COUNTRY]:
            action.errors.legal_info &&
            action.errors.legal_info[PROFILE_FIELD.RESIDENCE_COUNTRY]
              ? action.errors.legal_info[PROFILE_FIELD.RESIDENCE_COUNTRY]
              : INITIAL_STATE.errors[PROFILE_FIELD.RESIDENCE_COUNTRY],

          [SIGNUP_FIELDS.AGREEMENT]:
            action.errors.legal_info &&
            action.errors.legal_info[SIGNUP_FIELDS.AGREEMENT]
              ? true
              : INITIAL_STATE.errors[SIGNUP_FIELDS.AGREEMENT],
        },
      };

    case SET_PROFILE:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.data,
        },
        errors: {
          ...state.errors,
          ...Object.keys(action.data).reduce(
            (newObj, key) => ({ ...newObj, [key]: undefined }),
            {}
          ),
        },
      };

    case SET_ACCOUNT_TYPE:
      return {
        ...state,
        data: {
          ...state.data,
          ...action.data,
        },
        isCompany:
          action.data[PROFILE_FIELD.ACCOUNT_TYPE] === ACCOUNT_TYPE.COMPANY,
      };

    case SET_COUNTRY:
      return {
        ...state,
        data: {
          ...state.data,
          [PROFILE_FIELD.RESIDENCE_COUNTRY]:
            action.country !== undefined ? action.country.id : undefined,
          [PROFILE_FIELD.VAT]:
            action.country !== undefined
              ? state.data[PROFILE_FIELD.VAT]
              : undefined,
        },
        errors: {
          ...state.errors,
          [PROFILE_FIELD.RESIDENCE_COUNTRY]: undefined,
        },
        isVatCountry:
          action.country !== undefined ? action.country.isVat : false,
      };

    case TOGGLE_TERMS_MODAL:
      return {
        ...state,
        isTermsShow: !action.currentPosition,
      };

    case SET_REF_ID:
      return {
        ...state,
        data: {
          ...state.data,
          ref_id: action.refId,
        },
      };

    default:
      return state;
  }
}
